import { generateAndDownloadSparePartItemStockLabelQuery } from './generateAndDownloadSparePartItemStockLabelQuery';
import { getBillingDocumentLinkQuery } from './getBillingDocumentLinkQuery';
import uploadFileAttachmentsFromControlCommand from './uploadFileAttachmentsFromControlCommand';

export const DocumentService = {
  uploadFileAttachmentsFromControlCommand,
  getBillingDocumentLinkQuery,
  generateAndDownloadSparePartItemStockLabelQuery,
};
